import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './assets/scss/tailwind.css';
import './assets/themes/scss/core.scss';
import './assets/scss/index.scss';
import {
  applySiteBrandingToDocument,
  getStoredSiteBranding,
  storeSiteBranding,
} from './lib/siteBranding';
import { getSiteBranding } from './apis/settings';

applySiteBrandingToDocument(getStoredSiteBranding());
getSiteBranding()
  .then((branding) => applySiteBrandingToDocument(storeSiteBranding(branding)))
  .catch(() => applySiteBrandingToDocument(getStoredSiteBranding()));

// Prevent iOS/Android horizontal edge swipe from triggering browser history navigation.
if (typeof window !== 'undefined') {
  const isTouchDevice =
    'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

  if (isTouchDevice) {
    let startX = 0;
    let startY = 0;
    let isEdgeSwipe = false;
    const EDGE_THRESHOLD = 24;

    window.addEventListener(
      'touchstart',
      (event) => {
        const touch = event.touches && event.touches[0];
        if (!touch) return;

        startX = touch.clientX;
        startY = touch.clientY;
        isEdgeSwipe =
          startX <= EDGE_THRESHOLD || startX >= window.innerWidth - EDGE_THRESHOLD;
      },
      { passive: true },
    );

    window.addEventListener(
      'touchmove',
      (event) => {
        if (!isEdgeSwipe) return;

        const touch = event.touches && event.touches[0];
        if (!touch) return;

        const deltaX = touch.clientX - startX;
        const deltaY = touch.clientY - startY;
        const isHorizontalSwipe =
          Math.abs(deltaX) > 10 && Math.abs(deltaX) > Math.abs(deltaY);

        if (isHorizontalSwipe) {
          event.preventDefault();
        }
      },
      { passive: false },
    );
  }
}

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('app'),
);
